import { useState, useEffect, useRef } from "react";
import { Tooltip, Badge, IconButton, Chip, Typography, Box, Button } from "@mui/material";

import { toast } from "react-toastify";
import MaterialTable from "material-table";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import VerifiedIcon from "@mui/icons-material/Verified";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import {
  GetAtsJobKanbanHelper,
  GetAtsJobKanbanOfferHelper,
  PreScreenCandidateEmailHelper,
} from "../../../../helper/AtsJobKanbanHelper";
import { useDispatch, useSelector } from "react-redux";
import { GetAtsPythonPreScreenScoreAction } from "../../../../../../../store/ATS/ProfileScore/Action";
import AutoModeIcon from "@mui/icons-material/AutoMode";
import AICongifWarningPopup from "../../../../helper/Ancillary/AICongifWarningPopup";
import SendIcon from "@mui/icons-material/Send";
import Popup from "../../../../../Base/views/Popup";

function AIScoreGrid({ currentJobData, filters, sortValue }) {
  const dispatch = useDispatch();
  const [elements, setElements] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [kanbanUserLoading, setKanbanUserLoading] = useState(false);
  const { pythonScreeningLoading } = useSelector(
    (state) => state.AtsReducer?.AtsProfileScoreReducer,
  );
  const { AiConfigLoading, ModelTestingLoading } = useSelector(
    (state) => state.AncillaryReducer?.AIConfigReducer,
  );
  const aiConfigPopupRef = useRef();

  useEffect(() => {
    if (
      filters?.assignee_filter?.length > 0 ||
      filters?.proposed_filter?.length > 0 ||
      (filters?.stage_filter && filters.stage_filter.ats_job_stages_id) ||
      sortValue?.name === "priority"
    ) {
      let precruiter = [];
      let propose = [];
      filters?.assignee_filter?.forEach((res) =>
        precruiter.push(res?.recruiter_id),
      );
      filters?.proposed_filter?.forEach((res) =>
        propose.push(res?.recruiter_id),
      );
      const assigned_to_id =
        filters?.assignee_filter?.length > 0
          ? construcData(
              filters?.assignee_filter,
              "assigned_to_id",
              "recruiter_id",
            )
          : null;
      const proposed_by_name =
        filters?.proposed_filter?.length > 0
          ? construcData(
              filters?.proposed_filter,
              "proposed_by_name",
              "proposed_by_name",
            )
          : null;
      const stage_id =
        filters?.stage_filter && filters.stage_filter.ats_job_stages_id
          ? JSON.stringify([
              { stage_id: filters.stage_filter.ats_job_stages_id },
            ])
          : null;

      if (currentJobData?.offer_letter) {
        GetAtsJobKanbanOfferHelper({
          ats_jobpost_id: currentJobData?.ats_jobpost_id,
          assigned_to_id: assigned_to_id,
          proposed_by_name: proposed_by_name,
          ats_job_stages_id: stage_id,
          sort_order: sortValue?.order,
        }).then((res) => {
          res?.data?.statuscode === 200 && setElements(res?.data?.data);
        });
      } else {
        GetAtsJobKanbanHelper({
          ats_jobpost_id: currentJobData?.ats_jobpost_id,
          assigned_to_id: assigned_to_id,
          proposed_by_name: proposed_by_name,
          ats_job_stages_id: stage_id,
          sort_order: sortValue?.order,
        }).then((res) => {
          res?.data?.statuscode === 200 && setElements(res?.data?.data);
        });
      }
    } else {
      getKanbanData();
    }
    // eslint-disable-next-line
  }, [filters, sortValue]);

  const construcData = (value, label, key) => {
    var temp = [];
    value?.forEach((res) => {
      temp.push({ [label]: res[key] });
    });
    return JSON.stringify(temp);
  };
  const getKanbanData = () => {
    setKanbanUserLoading(true);
    if (currentJobData?.offer_letter) {
      GetAtsJobKanbanOfferHelper({
        ats_jobpost_id: currentJobData?.ats_jobpost_id,
      }).then((res) => {
        setKanbanUserLoading(false);
        res?.data?.statuscode === 200 && setElements(res?.data?.data);
      });
    } else {
      GetAtsJobKanbanHelper({
        ats_jobpost_id: currentJobData?.ats_jobpost_id,
      }).then((res) => {
        setKanbanUserLoading(false);
        res?.data?.statuscode === 200 && setElements(res?.data?.data);
      });
    }
  };

  // generate AI Candidate Screening Score
  const handleGenerateScreeningScore = () => {
    const screeningCompleted = (selectedRows ?? []).filter(
      (el) => el?.f_prescreen_response_fk !== "0",
    );
    if (screeningCompleted?.length === 0) {
      toast.warning("Please select at least one verified candidate");
      return;
    }
    if (aiConfigPopupRef.current) {
      aiConfigPopupRef.current.validateAIConfig().then((res) => {
        if (res.ok) {
          const candidateJobIds = screeningCompleted?.map(
            (el) => el?.candidate_job_id,
          );
          dispatch(
            GetAtsPythonPreScreenScoreAction(
              { candidate_job_id: candidateJobIds },
              (error, result) => {
                if (!error && result) {
                  setSelectedRows([]);
                  getKanbanData();
                  toast.success("Screening score generated successfully");
                } else {
                  toast.error("Something went wrong");
                }
              },
            ),
          );
        }
      });
    }
  };
  // send assessment link
  const [openprescreen, setOpenPreScreen] = useState(false);
  const [currentData, setCurrentData] = useState(null);
  const handleSendAssessment = (rowData) => {
    setOpenPreScreen(true);
    setCurrentData(rowData);
  };
  const handleSend = () => {
    PreScreenCandidateEmailHelper({
      jobData: currentJobData,
      kanban_data: currentData,
    });
    setOpenPreScreen(false);
  };
  return (
    <>
      <MaterialTable
        isLoading={kanbanUserLoading}
        columns={[
          {
            title: "Name",
            cellStyle: { padding: "10px 10px 10px 13px" },
            field: "full_name",
            grouping: false,
            render: (rowData) => {
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <span style={{ margin: "0px 0px 0px 0px" }}>
                    {rowData?.full_name}
                  </span>
                  {rowData?.flag_reason && (
                    <Tooltip title={rowData?.flag_reason}>
                      <FlagOutlinedIcon fontSize="small" color="error" />
                    </Tooltip>
                  )}
                </div>
              );
            },
          },
          {
            title: (
              <span>
                AI Job Score&nbsp;
                <Tooltip
                  title="AI score indicating candidate-job match. Available for verified candidates only."
                  placement="bottom"
                  arrow
                >
                  <InfoOutlinedIcon
                    fontSize="small"
                    color="action"
                    style={{ verticalAlign: "middle", cursor: "pointer" }}
                  />
                </Tooltip>
              </span>
            ),
            cellStyle: { padding: "10px 10px 10px 17px" },
            field: "final_score",
            grouping: false,
            render: (rowData) =>
              rowData?.final_score ? (
                <ScoreChip score={rowData?.final_score} />
              ) : (
                "N/A"
              ),
          },
          {
            title: (
              <span>
                Pre-Screening Score&nbsp;
                <Tooltip
                  title="AI evaluation of the candidate's written responses submitted in the pre-screening assessment."
                  placement="bottom"
                  arrow
                >
                  <InfoOutlinedIcon
                    fontSize="small"
                    color="action"
                    style={{ verticalAlign: "middle", cursor: "pointer" }}
                  />
                </Tooltip>
              </span>
            ),
            cellStyle: { padding: "10px 10px 10px 17px" },
            field: "prescreen_textual_score",
            grouping: false,
            render: (rowData) =>
              rowData?.prescreen_textual_score ? (
                <ScreeningScoreChip score={rowData?.prescreen_textual_score} />
              ) : (
                "N/A"
              ),
          },
          {
            title: (
              <span>
                Pre-Screening Video Score&nbsp;
                <Tooltip
                  title="AI evaluation of the candidate's recorded video responses based on clarity, relevance and communication."
                  placement="bottom"
                  arrow
                >
                  <InfoOutlinedIcon
                    fontSize="small"
                    color="action"
                    style={{ verticalAlign: "middle", cursor: "pointer" }}
                  />
                </Tooltip>
              </span>
            ),
            cellStyle: { padding: "10px 10px 10px 17px" },
            field: "prescreen_video_score",
            grouping: false,
            render: (rowData) =>
              rowData?.prescreen_video_score ? (
                <ScreeningScoreChip score={rowData?.prescreen_video_score} />
              ) : (
                "N/A"
              ),
          },
          {
            title: "Feedback Score",
            cellStyle: { padding: "10px 10px 10px 30px" },
            field: "priority",
            grouping: false,
            render: (rowData) => rowData?.priority || "N/A"
          },
          {
            title: (
              <span>
                Send Assessment&nbsp;
                <Tooltip
                  title={"Send screening assessment link to candidate"}
                  placement="bottom"
                  arrow
                >
                  <InfoOutlinedIcon
                    fontSize="small"
                    color="action"
                    style={{ verticalAlign: "middle", cursor: "pointer" }}
                  />
                </Tooltip>
              </span>
            ),
            cellStyle: { padding: "10px 10px 10px 17px" },
            field: "final_score",
            grouping: false,
            sorting: false,
            render: (rowData) => (
              <Tooltip
                title={
                 !currentJobData?.prescreen_template_id
                  ? "Please set pre-screen template for this job first"
                  : rowData?.is_verified === false ? "Verify candidate first"
                  : rowData?.f_prescreen_response_fk === "0"
                  ? "Send assessment link"
                  : "Assessment already submitted"
                }
              >
                <span>
                  <IconButton
                    size="small"
                    disabled={rowData?.f_prescreen_response_fk !== "0" || !currentJobData?.prescreen_template_id || rowData?.is_verified === false}
                    onClick={() => handleSendAssessment(rowData)}
                  >
                    <SendIcon
                      sx={{
                        fontSize: 20,
                      }}
                    />
                  </IconButton>
                </span>
              </Tooltip>
            ),
          },
          {
            title: "Status",
            cellStyle: { padding: "5px 10px 10px 5px" },
            field: "is_verified",
            grouping: false,
            sorting: false,
            render: (rowData) => {
              return rowData?.is_verified ? (
                <VerifiedIcon style={{ color: "green" }} />
              ) : (
                <VerifiedOutlinedIcon style={{ color: "red" }} />
              );
            },
          },
        ]}
        data={elements || []}
        options={{
          maxBodyHeight: "65vh",
          minBodyHeight: "65vh",
          rowStyle: { fontSize: "13px" },
          headerStyle: {padding: "5px 2px"},
          sorting: true,
          search: true,
          searchText: "",
          searchFieldAlignment: "right",
          searchAutoFocus: true,
          searchFieldVariant: "standard",
          filtering: false,
          paging: true,
          pageSizeOptions: [25, 50],
          pageSize: 25,
          paginationType: "stepped",
          showFirstLastPageButtons: false,
          paginationPosition: "bottom",
          exportButton: false,
          exportAllData: true,
          exportFileName: `Candidates Details ${currentJobData?.title}`,
          addRowPosition: "first",
          selection: true,
          selectionProps: (rowData) => ({
            disabled:
              AiConfigLoading || ModelTestingLoading || pythonScreeningLoading || rowData?.f_prescreen_response_fk === "0"
          }),
          actionsColumnIndex: -1,
          showSelectAllCheckbox: false,
          showTextRowsSelected: true,
          grouping: false,
          columnsButton: false,
        }}
        actions={[
          {
            icon: () => (
              <Badge
                badgeContent={selectedRows?.length || 0}
                color="secondary"
                invisible={selectedRows?.length === 0}
                sx={{
                  "& .MuiBadge-badge": {
                    right: -5,
                    top: 8,
                    fontSize: "0.65rem",
                    fontWeight: 600,
                    minWidth: 16,
                    height: 16,
                  },
                }}
              >
                <IconButton
                  onClick={handleGenerateScreeningScore}
                  disabled={
                    selectedRows?.length === 0 ||
                    pythonScreeningLoading ||
                    AiConfigLoading ||
                    ModelTestingLoading
                  }
                  size="small"
                >
                  <AutoModeIcon
                    sx={{
                      animation:
                        pythonScreeningLoading ||
                        AiConfigLoading ||
                        ModelTestingLoading
                          ? "spin 1s linear infinite"
                          : "none",
                      "@keyframes spin": {
                        "0%": { transform: "rotate(0deg)" },
                        "100%": { transform: "rotate(360deg)" },
                      },
                    }}
                  />
                </IconButton>
              </Badge>
            ),
            tooltip:
              pythonScreeningLoading || AiConfigLoading || ModelTestingLoading
                ? "Generating score.."
                : selectedRows.length === 0
                  ? "Select candidate to generate screening assessment score"
                  : "Generate Screening Assessment Score",
            isFreeAction: selectedRows.length === 0 ? true : false,
          },
        ]}
        onSelectionChange={(rows) => setSelectedRows(rows)}
        title=""
      />
      <br />
      <AICongifWarningPopup
        ref={aiConfigPopupRef}
        validateFor="JD"
        closeReq={true}
      />
      <Popup
                fullWidth={true}
                maxWidth="sm"
                title="Confirmation"
                openPopup={openprescreen}
                setOpenPopup={setOpenPreScreen}
              >
                <Typography variant="h6">
                  Do you want to send mail to candidate ?
                </Typography>
                <Box sx={{ display: "flex", justifyContent: "flex-end", m: 2 }}>
                  <Button
                    className="mpl-secondary-btn"
                    variant="outlined"
                    onClick={(e) => setOpenPreScreen(false)}
                  >
                    Skip
                  </Button>
                  <Button
                    className="mpl-primary-btn"
                    variant="contained"
                    onClick={handleSend}
                    sx={{ ml: 2 }}
                  >
                    Send Mail
                  </Button>
                </Box>
              </Popup>
    </>
  );
}
const ScoreChip = ({ score }) => {
  const numericScore = parseFloat(score) || 0;
  const formattedScore = numericScore.toFixed(1);

  let bgColor = "#e57373";
  if (numericScore >= 70) bgColor = "#5cd737";
  else if (numericScore >= 40) bgColor = "#fecb03";

  return (
    <Chip
      label={`${formattedScore}%`}
      size="small"
      sx={{
        backgroundColor: bgColor,
        fontWeight: 600,
        fontSize: "0.65rem",
        height: 18,
        minWidth: 0,
        borderRadius: "4px",
        pt: "1px",
      }}
    />
  );
};
const ScreeningScoreChip = ({ score }) => {
  const numericScore = parseFloat(score) || 0;
  const formattedScore = numericScore.toFixed(1);

  let bgColor = "#e57373";
  if (numericScore >= 7) bgColor = "#5cd737";
  else if (numericScore >= 4) bgColor = "#fecb03";

  return (
    <Chip
      label={`${formattedScore}/10`}
      size="small"
      sx={{
        backgroundColor: bgColor,
        fontWeight: 600,
        fontSize: "0.65rem",
        height: 18,
        minWidth: 0,
        borderRadius: "4px",
        pt: "1px",
      }}
    />
  );
};
export default AIScoreGrid;
